export const mensajesInbox = {
  title: "Mensagens",

  noAccess: {
    description:
      "Para acessar a caixa de entrada de mensagens, você precisa ter seu próprio número do WhatsApp Business conectado nas configurações da sua conta.",
    connectButton: "Conectar WhatsApp",
  },

  search: {
    placeholder: "Buscar por telefone ou hóspede...",
  },

  filters: {
    allProperties: "Todas as propriedades",
    searchProperty: "Buscar propriedade...",
    filterTitle: "Filtrar mensagens",
    clearAll: "Limpar filtros",
    removeOne: "Remover «{filtro}»",
    someActive: "{count} filtros",
  },

  tabs: {
    all: "Todas",
    unread: "Não lidas",
    pinned: "Fixadas",
    archived: "Arquivadas",
    noReservation: "Sem reserva",
    otaBooking: "Booking.com",
    otaAirbnb: "Airbnb",
    otaExpedia: "Expedia",
    otaOther: "Outra OTA",
    unpaid: "Por pagar",
    paid: "Pagas",
    arrivingSoon: "Chegam em breve",
  },

  filterGroups: {
    chat: "Conversa",
    origin: "Origem",
    reservation: "Reserva",
  },

  list: {
    empty: "Nenhuma conversa",
    noMessages: "Nenhuma mensagem",
  },

  channels: {
    web: "Web",
    webConcierge: "Concierge web · Portal da estadia",
    otaMessage: "Mensagem de {provider}",
  },

  chat: {
    placeholderSelect: "Selecione uma conversa para começar",
    loading: "Carregando conversa...",
    dropToAttach: "Solte aqui para anexar arquivos",
    emptyThread: "Ainda não há mensagens nesta conversa",
    notSent: "Não enviada",
    sending: "Enviando...",
  },

  sender: {
    guest: "Hóspede",
    you: "Você",
    aiAgent: "Agente IA",
  },

  media: {
    document: "Documento",
    sharedLocation: "Localização compartilhada",
    attachment: "Anexo",
  },

  preview: {
    attachmentSent: "Anexo enviado",
    messageSent: "Mensagem enviada",
    attachmentReceived: "Anexo recebido",
    newMessage: "Nova mensagem",
  },

  mode: {
    aiAgent: "Agente IA",
    manual: "Manual",
  },

  automation: {
    disabledNotice:
      "O Agente IA não está ativo nesta propriedade: ele não vai responder, as mensagens você escreve.",
    aiActiveBanner:
      "O agente IA está respondendo a este hóspede automaticamente.",
  },

  faq: {
    title: "Perguntas frequentes",
  },

  composer: {
    placeholder: "Digite uma mensagem ou use / para inserir uma resposta...",
    hint: "Enter para enviar · Shift+Enter para nova linha",
  },

  actions: {
    newConversation: "Nova conversa",
    options: "Opções",
    attachFile: "Anexar arquivo",
  },

  alt: {
    flag: "Bandeira",
    sentImage: "Imagem enviada",
  },

  common: {
    file: "arquivo",
    notAvailable: "Não disponível",
  },

  nights: "{count} noite | {count} noites",

  arrival: {
    pending: "Data pendente",
    today: "Chega hoje",
    tomorrow: "Chega amanhã",
    yesterday: "Chegou ontem",
    inDays: "Em {count} dias",
    daysAgo: "Chegou há {count} dias",
  },

  reservationStatus: {
    booked: "Confirmada",
    cancelled: "Cancelada",
    pending: "Pendente",
    checked_in: "Check-in realizado",
    checked_out: "Check-out realizado",
  },

  reservationPanel: {
    title: "Reserva vinculada",
    stayEnded: "O hóspede não está mais hospedado",
    checkIn: "Check-in",
    checkOut: "Check-out",
    room: "Quarto",
    reservation: "Reserva",
    phone: "Telefone",
    viewReservation: "Ver reserva",
    noReservationTitle: "Nenhuma reserva vinculada",
    noReservationOta:
      "Esta conversa veio de {channel} via Channex e ainda não está vinculada a uma reserva local.",
    noReservationWhatsapp:
      "Este contato escreveu para o WhatsApp conectado, mas ainda não está vinculado a uma reserva.",
    assignReservation: "Atribuir reserva",
    createReservation: "Criar reserva",
    assignExisting: "Atribuir reserva existente",
    searchPlaceholder: "Buscar por nome ou código...",
    noReservationsFound: "Nenhuma reserva encontrada",
    placeholderContext: "Selecione uma conversa para ver o contexto",
    propertyUnavailable: "Propriedade indisponível",
  },

  contextMenu: {
    pin: "Fixar conversa",
    unpin: "Desafixar conversa",
    archive: "Arquivar conversa",
    unarchive: "Desarquivar conversa",
  },

  waStatus: {
    read: "Lida",
    delivered: "Entregue",
    queued: "Na fila",
    failed: "Falhou",
    sent: "Enviada",
  },

  waFailTitle: {
    noWhatsapp: "Sem WhatsApp",
    invalidNumber: "Número inválido",
    notSent: "Não enviada",
  },

  waErrors: {
    generic: "Não foi possível enviar esta mensagem pelo WhatsApp.",
  },

  waErrorShort: {
    e131042: "problema de pagamento na conta do WhatsApp",
    e131026: "o número não pode receber WhatsApp",
    e131053: "o WhatsApp não conseguiu baixar o arquivo",
    e132000: "dados ausentes no modelo",
    e131009: "a mensagem não atende aos requisitos do WhatsApp",
  },

  toasts: {
    aiActiveSwitchManual:
      "O agente IA está ativo. Mude para o modo manual para responder.",
    pinned: "Conversa fixada",
    unpinned: "Conversa desafixada",
    archived: "Conversa arquivada",
    unarchived: "Conversa desarquivada",
    reservationAssigned: "Reserva atribuída: {name}",
    reservationUnassigned: "Reserva desatribuída",
    selectPropertyToCreate:
      "Selecione uma propriedade para criar a reserva a partir deste chat.",
    userNotResolved: "Não foi possível resolver o usuário do painel.",
    aiNotEnabledConfig:
      "Esta propriedade não tem o Agente IA ativado. Ative-o nas configurações do anúncio.",
    aiEnabledForChat: "Agente IA ativado para esta conversa",
    manualEnabledForChat: "Modo manual ativado para esta conversa",
    templateSent: "Modelo enviado com sucesso.",
  },

  errors: {
    inboxNotActive:
      "A caixa de entrada de mensagens não está ativa para esta conta, ou o WhatsApp comercial ainda precisa ser conectado.",
    openConversation: "Não foi possível abrir a conversa",
    sendMessage: "Não foi possível enviar a mensagem. Verifique sua conexão com o WhatsApp.",
    pin: "Erro ao fixar a conversa",
    archive: "Erro ao arquivar",
    loadReservations: "Erro ao carregar as reservas",
    assignReservation: "Erro ao atribuir a reserva",
    unassignReservation: "Erro ao desatribuir a reserva",
    updateMode: "Não foi possível atualizar o modo desta conversa",
    reactivationTemplate: "Não foi possível enviar o modelo de reativação.",
  },
};
